import { Button as MaterialButton } from '@material-ui/core';
import { ButtonProps } from '@material-ui/core/Button';
import React from 'react';
import { alignSelf, height, justifySelf, maxHeight, maxWidth, minHeight, minWidth, space, width } from 'styled-system';
import { styled } from '~ui-kit/styled-components';

/**
 * @deprecated Use ~ui-kit/components/button instead.
 */
export function Button({ children, ...rest }: ButtonProps) {
  return <StyledButton {...rest}>{children}</StyledButton>;
}

const StyledButton = styled(MaterialButton)`
  ${alignSelf};
  ${justifySelf};
  ${height};
  ${minHeight};
  ${maxHeight};
  ${width};
  ${minWidth};
  ${maxWidth};
  ${space};
`;
